// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const _typeof = (o: any): string => {
  if ('function' == typeof Symbol && 'symbol' == typeof Symbol.iterator) {
    return typeof o
  }
  return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype
    ? 'symbol'
    : typeof o
}

export default _typeof
